import { createRouter, createWebHistory } from 'vue-router';
import { erpConnectRoutes } from '@/modules/erp-connect/routes';
import { useAuthStore } from '@/modules/auth/stores/authStore';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...erpConnectRoutes,
    { path: '/settings', name: 'settings', component: () => import('@/shared/ui/Einstellungen.vue'), meta: { requiresRole: '1a-erp-admin' } },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/shared/ui/NotFound.vue') },
  ],
});

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore();

  // Prüfen, ob die Route eine spezifische Rolle erfordert
  const requiredRole = to.meta.requiresRole as string | undefined;

  if (requiredRole) {
    // Prüfen, ob der Benutzer die erforderliche Rolle hat
    if (!authStore.roles.includes(requiredRole)) {
      // Benutzer hat nicht die erforderliche Rolle -> Weiterleitung zum Dashboard
      console.warn(`Zugriff verweigert: Rolle "${requiredRole}" erforderlich`);
      return next({ name: 'erp-connect.dashboard' });
    }
  }

  next();
});

export default router;
